import { useInView } from "react-intersection-observer";
import "./index.scss";
import classNames from "classnames";
const H2 = ({ text }: { text: any }) => {
  const { ref, inView, entry } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });
  const title = text?.split(" ");
  return (
    <h2 className={classNames("title2", inView && "animated")} ref={ref}>
      <span
        className="anim-block"
        dangerouslySetInnerHTML={{ __html: text }}
      ></span>
    </h2>
  );
};

export default H2;

//  {
//    title?.map((c: any, i: number) => (
//      <span
//        style={{
//          overflow: "hidden",
//        }}
//      >
//        <span
//          className="anim-block"
//          key={i}
//          style={{
//            transitionDelay: (i + 1) * 0.2 + "s",
//          }}
//        >
//          {c}{" "}
//        </span>
//      </span>
//    ));
//  }
